const THEMES = {
  default: {
    input: "padding: 15px 23px; font-size: 16px; font-weight: 400; line-height: 1.4; color: #fff; background-color: #2F3242; background-clip: padding-box; border: 0 solid #ced4da; appearance: none; border-radius: 0.375rem; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;",
    focus: "padding: 15px 23px; font-size: 16px; font-weight: 400; line-height: 1.4; color: #fff; background-color: #2F3242; background-clip: padding-box; border: 0 solid #ced4da; appearance: none; border-radius: 0.375rem; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; outline: none;",
    inputHeight: "53px"
  },
  "gildepass-v5": {
    input: "padding: 15px 23px; font-size: 16px; font-weight: 400; line-height: 1.4; color: #000; background-color: rgba(255, 255, 255, 0.85); background-clip: padding-box; border: 2px solid #E5D8D48C; appearance: none; border-radius: 0.375rem; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;",
    focus: "padding: 15px 23px; font-size: 16px; font-weight: 400; line-height: 1.4; color: #000; background-color: #fff; background-clip: padding-box; border: 2px solid #315A89; appearance: none; border-radius: 0.375rem; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; outline: none;",
    inputHeight: "56px"
  }
}

const FALLBACK_THEME = "default"

const supportedCardtypes = ["V", "M", "A"]

export const buildFieldConfiguration = (locale) => {
  const theme = getTheme()

  return {
    fields: {
      // cardtype: {
      //   selector: "cardtype", // put name of your div-container here
      //   cardtypes: supportedCardtypes, // define possible cardtypes in PAYONE iFrame
      //   style: theme.input + "width: 100%;",
      //   styleFocus: theme.focus + "width: 100%;",
      // },
      cardtype: {
        selector: "cardtype",
        cardtypes: supportedCardtypes
      },
      cardpan: {
        selector: "cardpan", // put name of your div-container here
        type: "text", // text (default), password, tel
        style: theme.input + "width: 100%;",
        styleFocus: theme.focus + "width: 100%;",
      },
      cardcvc2: {
        selector: "cardcvc2", // put name of your div-container here
        type: "password", // select(default), text, password, tel
        size: "4",
        maxlength: "4",
        style: theme.input + "width: 80px;",
        styleFocus: theme.focus + "width: 80px;",
      },
      cardexpiremonth: {
        selector: "cardexpiremonth", // put name of your div-container here
        type: "select", // select(default), text, password, tel
        style: theme.input + "width: 70px;",
        styleFocus: theme.focus + "width: 70px;",
        size: "2",
        maxlength: "2",
        iframe: {
          width: "81px"
        }
      },
      cardexpireyear: {
        selector: "cardexpireyear", // put name of your div-container here
        type: "select", // select(default), text, password, tel
        style: theme.input + "width: 100px;",
        styleFocus: theme.focus + "width: 100px;",
        iframe: {
          width: "100px"
        }
      }
    },
    defaultStyle: {
      iframe: {
        height: theme.inputHeight,
        width: "auto"
      }
    },
    autoCardtypeDetection: {
      supportedCardtypes: supportedCardtypes,
      callback: function(detectedCardtype) {
        // console.log(`Detected card type: ${detectedCardtype}`)
      },
  },
    error: "errorOutput", // area to display error-messages (optional)
    language: Payone.ClientApi.Language[locale] // Language to display error-messages
  }
}

export const buildRequestConfiguration = (options) => {
  const mode = options["mode"] || "test"
  const merchantId = options["merchantId"]
  const accountId = options["accountId"]
  const portalId = options["portalId"]
  const hash = options["hash"]

  return {
    request: "creditcardcheck",
    responsetype: "JSON",
    mode: mode,
    mid: merchantId,
    aid: accountId,
    portalid: portalId,
    encoding: "UTF-8",
    storecarddata: "yes",
    hash: hash
  }
}

const getTheme = () => {
  try {
    let themeName = document.body.dataset.orderFlowTheme || FALLBACK_THEME
    if (!THEMES[themeName]) { themeName = FALLBACK_THEME }

    return THEMES[themeName]
  } catch(e) { return THEMES[FALLBACK_THEME] }
}
